<template>
  <div class="form-item" :class="{ 'form-error': isErrorShown }">
    <div class="form-item--with-submit">
      <form @submit.prevent="searchSalon">
        <input
          v-model="salon"
          name="text"
          class="input"
          type="text"
          :placeholder="placeholder"
          :aria-label="ariaLabel"
          @keydown="hideError"
        />

        <button type="submit">
          <svg class="icon">
            <title>{{ svgIcon }}</title>
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#search"></use>
          </svg>
        </button>
      </form>
    </div>
    <p v-show="isError" :id="errorId" class="form-error--message" role="alert">{{ errorTxt }}</p>
  </div>
</template>

<script>
import 'whatwg-fetch';

export default {
  name: 'find-a-salon',
  props: {
    errorTxt: { type: String },
    placeholder: { type: String },
    method: { type: String },
    action: { type: String },
    country: { type: String },
    priority: { type: String },
    svgIcon: { type: String },
    tagging: { type: Object },
    errorId: { type: String },
    ariaLabel: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    salon: '',
    isError: false,
  }),
  methods: {
    searchSalon() {
      if (this.salon) {
        this.isError = false;

        /* istanbul ignore next */
        try {
          dataLayer.push(this.tagging);
        } catch {
          console.warn('datalayer is not defined');
        }

        /* istanbul ignore next */
          window.open(this.action + '?country=' + this.country + '&priority=' + this.priority + '&query=' + this.salon) // eslint-disable-line
      } else {
        this.isError = true;
      }
    },
    hideError() {
      this.isError = false;
    },
  },
};
</script>
